import React, { useState, useEffect } from "react";
import NavHeader from "../../Common/NavHeader";
import BreadCrumb from "../../Common/BreadCrumb";
import { getReportDetails } from "../api";
import useAppStore from "../../../store/global";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import DetailsTable from "./DetailsTable";


export default function DetailsHome() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const restName = queryParams.get('restaurant_name');

  const [reports, setReports] = useState([]);
  const { loading, setLoading} = useAppStore();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    getReportDetails(id)
      .then((data) => {
        setReports(data.report_details);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }, []);

  return (
    <>
      <NavHeader view="scrapper" />
      <div className="mx-2 mx-md-4" style={{ marginTop: "100px" }}>
        <BreadCrumb text={`Restaurants > ${restName} > Reports > Report Details`} />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <>
            <DetailsTable 
            reports={reports}
            />
          </>
        )}
      </div>
    </>
  );
}
